const styles = {
  card: {
    width: '100%',
  },
};

export default styles;
